import RoomType from '../roomType';
export default class Bedroom extends RoomType {
  constructor() {
    super();
    this.id = 'Bedroom';
    this.name = "Soverom";
    this.icon = "mdi-hotel";
    this.stateQuestions.questions.push(
      {
        'id': 'windows',
        'title': 'Vinduer og karmer',
        'active': true,
        'value': -1
      },
      {
        'id': 'cabinet',
        'title': 'Skap',
        'active': true,
        'value': -1
      }
    );
    this.contentTypes.options.unshift(
      {
        'id': 'cabinet',
        'title': 'Skapplass',
        'active': true,
        'value': -1
      },
      {
        'id': 'cabinet_possible',
        'title': 'Mulighet for skapplass',
        'active': true,
        'value': -1
      },
      {
        'id': 'onsuite',
        'title': 'Eget bad tilknyttet soverom',
        'active': false,
        'value': -1
      },
      {
        'id': 'sliding_cabinet',
        'title': 'Skyvedørsgarderobe',
        'active': false,
        'value': -1
      },
      {
        'id': 'cable_tv',
        'title': 'Uttak for kabel-TV',
        'active': false,
        'value': -1
      },
      {
        'id': 'office_space',
        'title': 'Mulighet for kontorplass',
        'active': false,
        'value': -1
      },
      {
        'id': 'balcony',
        'title': 'Utgang til balkong/terrasse',
        'active': false,
        'value': -1
      }
    );
  }
}